import { NgModule } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';

import { LoginRoutingModule } from './login-routing.module';
import { LoginComponent } from './login.component';
import { LoadingSpinnerModule } from '../../../shared/loading-spinner/loading-spinner.module';
import { LanguageSelectorModule } from '../../../shared/language-selector/language-selector.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import {
  SystemButtonModule,
  SystemInputTextModule,
  SystemLabelModule,
  SystemLinkModule,
  SystemCheckboxModule,
  SystemIconComponentModule,
  SystemLogoModule,
  SystemInputSetModule,
} from '@app/shared/ui-components';

@NgModule({
  declarations: [LoginComponent],
  imports: [
    CommonModule,
    LoginRoutingModule,
    LoadingSpinnerModule,
    LanguageSelectorModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    NgOptimizedImage,
    SystemButtonModule,
    SystemInputTextModule,
    SystemLabelModule,
    SystemLinkModule,
    SystemCheckboxModule,
    SystemIconComponentModule,
    SystemLogoModule,
    SystemInputSetModule,
  ],
})
export class LoginModule {}
